export const CB_CARD_REQUEST = 'CB_CARD_REQUEST';
export const CB_CARD_SUCCESS = 'CB_CARD_SUCCESS';
export const CB_CARD_FAIL = 'CB_CARD_FAIL';

export const CB_REMOVE_CARD_REQUEST = 'CB_REMOVE_CARD_REQUEST';
export const CB_REMOVE_CARD_SUCCESS = 'CB_REMOVE_CARD_SUCCESS';
export const CB_REMOVE_CARD_FAIL = 'CB_REMOVE_CARD_FAIL';
